








































































































































































































import _ from 'lodash'
import { Component, Vue } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import EventBus from '@/plugins/EventBus'
import { timeout, maskMoney } from '@/utils/common'
import RecalcularProcedimentosStore from '@/components/RemuneracaoMedica/financeiro/Store/RecalcularProcedimentosStore'

@Component
export default class ViewFinanceiroRecalcularProcedimentos extends Vue {
  loadDataTable: boolean = false
  get loadingDataTable() { return this.loadDataTable }
  set loadingDataTable(value: boolean) { this.loadDataTable = value }

  loadFiltrarDataTable: boolean = false
  get loadingFiltrarDataTable() { return this.loadFiltrarDataTable }
  set loadingFiltrarDataTable(value: boolean) { this.loadFiltrarDataTable = value }

  loadEnfileirarRecalculo: boolean = false
  get loadingEnfileirarRecalculo() { return this.loadEnfileirarRecalculo }
  set loadingEnfileirarRecalculo(value: boolean) { this.loadEnfileirarRecalculo = value }

  loadOpenModalRecalculo: string = ''
  get loadingOpenModalRecalculo() { return this.loadOpenModalRecalculo }
  set loadingOpenModalRecalculo(value: string) { this.loadOpenModalRecalculo = value }

  menuAnoMesReferenciaGeracaoRepasse: boolean = false
  get getMenuAnoMesReferenciaGeracaoRepasse() { return this.menuAnoMesReferenciaGeracaoRepasse }
  set getMenuAnoMesReferenciaGeracaoRepasse(value: boolean) { this.menuAnoMesReferenciaGeracaoRepasse = value }

  modalEnfileirarRecalculo: boolean = false
  get showModalEnfileirarRecalculo() { return this.modalEnfileirarRecalculo }
  set showModalEnfileirarRecalculo(value: boolean) { this.modalEnfileirarRecalculo = value }

  get getStore() {
    return getModule(RecalcularProcedimentosStore, this.$store)
  }

  get mesAnoCompetencia() {
    return this.getStore.mesAnoCompetencia
  }

  set mesAnoCompetencia(value) {
    this.getStore.setMesAnoCompetencia(value)
  }

  get fontePagadoraGerarRepasse() {
    return this.getStore.fontePagadoraId
  }

  set fontePagadoraGerarRepasse(value: string) {
    this.getStore.setFontePagadoraId(value)
  }

  get getFontePagadoraGerarRepasse() {
    return this.getStore.fontePagadoras
  }

  get itemsRecalcularProcedimentos() {
    return this.getStore.itemsRecalcularProcedimentos
  }

  get itemsTabelaPrecoProcedimentoTableHeader() {
    return [
      { text: '', value: '', align: 'left', sortable: false },
      { text: 'Fonte pagadora', value: 'fontePagadora', align: 'center', sortable: false },
      { text: 'Profissional executante', value: 'profissionalExecutante', align: 'center', sortable: false },
      { text: 'Número atendimento', value: 'numeroAtendimento', align: 'center', sortable: false },
      { text: 'Operadora', value: 'operadora', align: 'center', sortable: false },
      { text: 'Identificador HIS', value: 'identificadorHisProducaoProcedimento', align: 'center', sortable: false },
      { text: 'Ações', value: '', align: 'center', sortable: false },
    ]
  }

  async openModalRecalculo(item: any) {
    this.loadingOpenModalRecalculo = item.medicoProducaoProcedimentoId
    await timeout(500)
    this.getStore.setItemRecalcularProcedimento(item)
    this.showModalEnfileirarRecalculo = !this.showModalEnfileirarRecalculo
    this.loadingOpenModalRecalculo = ''
  }

  async getAllItems() {
    this.loadingDataTable = true
    await this.getStore.getAllProcedimentosRecalculo()
    this.loadingDataTable = false
  }

  async filtrarDataTable() {
    this.loadingFiltrarDataTable = true
    this.getPagina = 1
    await this.getStore.getAllProcedimentosRecalculo()
    this.loadingFiltrarDataTable = false
  }

  async enfileirarRecalculo() {
    this.loadEnfileirarRecalculo = true
    const response = await this.getStore.enfileirarRecalculo()
    if (response.success) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Item recalculado com sucesso!', icon: 'done', color: '#2E7D32' })
      this.showModalEnfileirarRecalculo = false
      await this.getAllItems()
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: 'Erro ao recalcular o item!', icon: 'warning', color: '#C62828' })
    }
    this.loadEnfileirarRecalculo = false
  }

  async init() {
    EventBus.$emit('setLoadingRequest', { status: true, text: 'Carregando' })
    this.getStore.clearMesAnoCompetencia()
    this.getStore.clearFontePagadoraId()
    await this.getStore.getFontePagadoraAll()
    EventBus.$emit('clearLoadingRequest')
  }

  async mounted() {
    await this.init()
  }

  maskMoneyUtil(value) {
    return maskMoney(value)
  }

  /**
   * Paginação
   */
  get itemsLength() {
    return Math.ceil(this.getTotal / this.getStore.qtdPorPagina)
  }

  get getTotal() {
    return this.getStore.totalItems || 0
  }

  get visibleResults() {
    if (this.$vuetify.breakpoint.smAndDown) return 4
    if (this.$vuetify.breakpoint.md) return 7
    if (this.$vuetify.breakpoint.lg) return 9
    return 15
  }

  get getPagina() {
    return this.getStore.pagina
  }

  set getPagina(value: number) {
    this.getStore.setPagina(value)
  }

  async getResults(pagina: number) {
    this.loadingDataTable = true
    this.getPagina = pagina
    await this.getStore.getAllProcedimentosRecalculo()
    this.loadingDataTable = false
  }
}
